// extracted by mini-css-extract-plugin
export default {"tableRowContainer":"UsersTableSkeletonRow_tableRowContainer__BI30R"};